export const state = getInitialState();


export const mutations = {

  /**
   * 装置の使用/不使用を設定します。
   * 仕掛データセット一覧画面にて仕掛データセット一覧データ行を押下時にtrueに設定されます。
   *
   * 仕掛データセット一覧画面の初期表示にてfalseに設定されます。
   *
   * @param {*} state
   * @param {*} useInstrument
   */
  useInstrument(state, useInstrument) {
    state.useInstrument = useInstrument;
  },

  /**
   * 仕掛データセット検索を実施した際に検索条件とした装置IDを設定
   *
   * @param {*} state
   * @param {*} selectedInstrumentIdOnEntryList
   */
  selectedInstrumentIdOnEntryList(state, selectedInstrumentId) {
    state.selectedInstrumentIdOnEntryList = selectedInstrumentId;
  },

  /**
   * すべてのstateを初期値に戻します。
   *
   * @param state
   */
  clearAll(state) {
    Object.assign(state, getInitialState());
  }
};

function getInitialState() {
  return {
    useInstrument: false,
    selectedInstrumentIdOnEntryList: null
  };
}
